/* eslint-disable no-shadow */

import * as types from '../mutation-types';
import helpers from '../helpers';
import * as api from '../../lib/api';

const state = {
  items: {},
};

const mutations = {
  [types.ADD_ASSETS](state, assets) {
    helpers.mutations.createItems(state, assets);
  },

  [types.UPDATE_ASSETS](state, assets) {
    helpers.mutations.updateItems(state, assets);
  },
};

const actions = {
  add({ commit }, assets) {
    commit(types.ADD_ASSETS, assets);
  },

  update({ commit }, assets) {
    commit(types.UPDATE_ASSETS, assets);
  },

  async load({ dispatch }) {
    const assets = await api.getAssets();
    dispatch('add', assets);
  },
};

const getters = {
  get(state) {
    return (id) => state.items[id];
  },

  getByIsin(state) {
    return (isin) => Object.values(state.items).find((item) => (item.isin === isin));
  },

  getAll(state) {
    return Object.values(state.items);
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true,
};
